// extracted by mini-css-extract-plugin
export default {"prefix":"CurrencyInput--prefix--b9ed68","fullBorder":"CurrencyInput--fullBorder--7fbc84","suffix":"CurrencyInput--suffix--eec21c"};